'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function () {
	if (window.isPointerfocusInited) {
		return;
	}

	window.isPointerfocusInited = true;

	var doc = document.documentElement;

	doc.addEventListener('keydown', function () {
		doc.classList.add('utilityfocus');
		doc.classList.remove('pointerfocus');
	});

	doc.addEventListener('mousedown', function () {
		doc.classList.remove('utilityfocus');
		doc.classList.add('pointerfocus');
	});
};